import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import profile from '../images/farhad.jpg';

const About = () => {
    return (
        <section className="about" id="about">
            <div className="max-width">
                <h2 className="title">About me</h2>
                <div className="about-content">
                    <div className="column left" data-aos="fade-right" data-aos-duration="1000">
                        <img src={profile} alt="" />
                    </div>
                    <div className="column right" data-aos="fade-left">
                        <div className="intro">Hi, I'm Farhad <span>glad to see you here</span></div>
                        <p className="short-details">
                            Since beginning my journey as a frontend developer, I've done some projects using HTML, CSS,
                            React, Node, Express, Mongodb. <br />
                            I am an enthusiastic and diligent full stack web developer with excellent knowledge and experience.
                            I can take on challenges in new environments to develop new skills.
                            <br /> I have already developed 10+ projects. Most of that are developed using JavaScript.
                            I have used react the most commonly used JavaScript library for front-end development and for backend I've used express - a Nodejs framework. And most of the projects I've used Mongo dB as a database. I have a clear knowledge of how to deploy a project on both the server side and the client side in Netlify, Firebase and Heroku.
                            I can take the level of accuracy concerning about the quality of the work and the presentation of the work and attention to detail.

                           <br /> Now, I am exploring Algorithm and Solving problems from various online judge.
                        </p>
                        <a target="_blank" href="https://drive.google.com/file/d/1gO2e5P-fBqAbuQAbV8VWy9PH0HfEVmkG/view?usp=sharing">Download CV</a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;